import { render, staticRenderFns } from "./OrganizationSettingsEditor.vue?vue&type=template&id=f9901b0a&scoped=true&"
import script from "./OrganizationSettingsEditor.vue?vue&type=script&lang=ts&"
export * from "./OrganizationSettingsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationSettingsEditor.vue?vue&type=style&index=0&id=f9901b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9901b0a",
  null
  
)

export default component.exports